let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aTu7U")).then(() => parcelRequire('kG2Cm'));